module.exports = __webpack_public_path__ + "img/battletrip_main_mo.a04c1e11.jpg";